import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=199e5273&"
import script from "./AboutMe.vue?vue&type=script&lang=ts&"
export * from "./AboutMe.vue?vue&type=script&lang=ts&"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=199e5273&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports